// extracted by mini-css-extract-plugin
module.exports = {"gallery":"gallery-module--gallery--2m57P","container":"gallery-module--container--1JghX","info":"gallery-module--info--1B5G9"};